module.exports = __webpack_public_path__ + "static/media/kongQiHosptial.34fcf0c0.png";